import type { ChaliceStore } from '../types';

export const selectBanner = (state: ChaliceStore) => state.banner;
